import { useSelector } from "react-redux";

import {
  getDeploymentAgeOptionsByDeploymentIdAndSpeciesId,
  getDeploymentBreedOptionsByDeploymentIdAndSpeciesId,
  getSexes,
} from "selectors";

interface SaleLotIds {
  age_id?: number | null;
  breed_id?: number | null;
  sex_id?: number | null;
}

interface SaleLotAttributeLabels {
  ageLabel: string | null;
  breedLabel: string | null;
  sexLabel: string | null;
}

export function useSaleLotAttributeLabels(
  saleLot: SaleLotIds,
  deploymentId: number,
  speciesId: number | null,
): SaleLotAttributeLabels {
  const ageOptions = useSelector(
    getDeploymentAgeOptionsByDeploymentIdAndSpeciesId(deploymentId, speciesId),
  );
  const breedOptions = useSelector(
    getDeploymentBreedOptionsByDeploymentIdAndSpeciesId(
      deploymentId,
      speciesId,
    ),
  );
  const sexes = useSelector(getSexes);

  const { age_id: ageId, breed_id: breedId, sex_id: sexId } = saleLot;

  const ageLabel = ageOptions.find(o => o.value === ageId)?.label || null;
  const breedLabel = breedOptions.find(o => o.value === breedId)?.label || null;
  const sexLabel = sexId ? sexes[sexId]?.name : null;

  return { ageLabel, breedLabel, sexLabel };
}
